<div class="box">
  <span class="icone icon_atencao"></span>
  <h1>
    <span class="orange-text">Importante:</span> Quanto maior a entrada, menor
    será a taxa e a sua parcela.
  </h1>
</div>
